export default __webpack_public_path__ + "static/media/pineapple.40f998d5.png";